module.exports = __webpack_public_path__ + "media/notice6.ffbc453c.mp3";